import React from 'react';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { CHART_TYPES } from '../../constants/chartTypes';
import { DATASET_WHATSAPP } from '../../constants/datasetScope';
import { ANALYTICS_COPY } from '../../constants/analyticsCopy';
import { getChartConfigureHintKey } from '../../utils/chartTypeMapping';

const WHATSAPP_CHART_IDS = ['number', 'line', 'table'];

export function chartTypesForDataset(dataset) {
  if (dataset === DATASET_WHATSAPP) {
    return CHART_TYPES.filter((item) => WHATSAPP_CHART_IDS.includes(item.id));
  }
  return CHART_TYPES;
}

export default function VisualizationSelect({
  value,
  onChange,
  dataset = '',
  disabled = false,
}) {
  const options = chartTypesForDataset(dataset);
  const selectedId = options.some((item) => item.id === value)
    ? value
    : (options[0]?.id || 'number');
  const hintKey = getChartConfigureHintKey(selectedId);
  const whatsappHints = {
    number: ANALYTICS_COPY.whatsappVizLockedHint,
    line: ANALYTICS_COPY.whatsappLineHint,
    table: ANALYTICS_COPY.whatsappTableHint,
  };
  const helperText = dataset === DATASET_WHATSAPP
    ? (whatsappHints[selectedId] || ANALYTICS_COPY.whatsappVizLockedHint)
    : (ANALYTICS_COPY[hintKey] || '');

  return (
    <TextField
      id="analytics-visualization"
      select
      fullWidth
      label={ANALYTICS_COPY.chartTypeSectionTitle}
      value={selectedId}
      disabled={disabled}
      helperText={helperText}
      onChange={(event) => onChange(event.target.value)}
      SelectProps={{
        renderValue: (selected) => {
          const item = options.find((option) => option.id === selected);
          return item?.label || selected;
        },
      }}
    >
      {options.map((chart) => {
        const Icon = chart.Icon;
        return (
          <MenuItem key={chart.id} value={chart.id}>
            <ListItemIcon sx={{ minWidth: 36 }}>
              <Icon fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={chart.label}
              secondary={chart.description}
              secondaryTypographyProps={{ noWrap: true }}
            />
          </MenuItem>
        );
      })}
    </TextField>
  );
}
